// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__Cda0k","layout-body":"style_layout-body__Y84Pk"};